import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { tagKeys } from '@/shared/lib/query/queryKeys';

import type { TagDetailItem } from '@/entities/tags/domain';

import { getTagsApi } from '@/features/tags/api';

type UseTagsParams = {
  parent: string;
  limit?: number;
  fields?: string;
};

type TagsResponse = {
  data: TagDetailItem[];
  paging: {
    total: number;
    before?: string;
    after?: string;
  };
};

export const useTags = ({ parent, limit = 3000, fields = 'usageCount' }: UseTagsParams) => {
  return useQueryWithBoundary<TagsResponse>({
    queryKey: tagKeys.tags(parent),
    queryFn: () => getTagsApi({ parent, limit, fields }),
    enabled: !!parent,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
